module.exports = __webpack_public_path__ + "894f295be81dd1d3c6a92880b711f937.png";